import { toE164Digits, phoneDigitsOnly } from "./phone";

/** Dígitos do telefone do cliente na conversa (cadastro). */
export function getClientPhoneDigits(conversation) {
  if (!conversation) return "";
  const raw =
    conversation.celular ?? conversation.phone ?? conversation.phoneNumber ?? "";
  return phoneDigitsOnly(raw);
}

/** E.164 sem '+' a partir do cadastro na conversa (inferência BR quando aplicável). */
export function getClientPhoneE164(conversation, defaultCountry = "BR") {
  if (!conversation) return "";
  const raw =
    conversation.celular ?? conversation.phone ?? conversation.phoneNumber ?? "";
  if (!raw) return "";
  return toE164Digits(String(raw), defaultCountry) || phoneDigitsOnly(raw);
}

export function hasClientPhoneRegistered(conversation) {
  return getClientPhoneDigits(conversation).length >= 8;
}

const PHONE_REQUIRED_CHANNEL_TYPES = new Set(["WhatsApp", "SMS", "Phone", "Telefone"]);

export function channelTypeRequiresClientPhone(channelType) {
  if (channelType == null || channelType === "") return false;
  return PHONE_REQUIRED_CHANNEL_TYPES.has(String(channelType));
}
